import "../../../css/OnRoad.css";

export const Footer = () => {
    return (
        <div className="onroad-footer">
            <div className="footer-content">
                <div className="footer-logo-section">
                    <img 
                        src="/logosafite2.png" 
                        alt="SAFITE Logo" 
                        className="footer-logo"
                    />
                </div>
                <div className="footer-text">
                    <div className="footer-app-name">OnRoad Logistics</div>
                    <div className="footer-credits">Desarrollado por SAFITE S.A.S</div>
                </div>
            </div>
        </div>
    );
};

export default Footer;